export const isBusinesses = (path: string) => {
  return (
    process.env.APP_NAME !== "PREMIUM" &&
    process.env.APP_NAME !== "REPORTS" &&
    !path.includes("individuals")
  );
};
